import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'convertFullDate'
})
export class ConvertFullDatePipe implements PipeTransform {

    transform(date: any, args?: any): any {
        return date && moment(date).isValid() ? moment(date).format('DD/MM/YYYY HH:mm:ss') : '-';
    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/pipe/convert-full-date.pipe.ts